import { render, staticRenderFns } from "./OwnerShareInput.vue?vue&type=template&id=83135960&scoped=true&"
import script from "./OwnerShareInput.vue?vue&type=script&lang=js&"
export * from "./OwnerShareInput.vue?vue&type=script&lang=js&"
import style0 from "./OwnerShareInput.vue?vue&type=style&index=0&id=83135960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83135960",
  null
  
)

export default component.exports